import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { googleAds } from "appConfig";

import { getModuleContext } from "../../../HOCs";
import {
  selectSubLevel,
  getSubLevelCount,
  selectSubLevelSearch,
  selectMakeDatasource,
  deleteSubLevelSearch,
  selectNewAds,
} from "../../../routes/Ad/ad.ducks";
import {
  isMobileScreen,
  getWindowWidth,
  checkEmptyObject
} from "../../../services/utils";
import SubLevel1Desktop from "./SubLevel1Desktop";
import {
  selectCurrentCategories,
  selectCurrentModuleName
} from "../../App/selectors";
import BreadcrumbBar from "../../../components/BreadcrumbBar";
import styles from "../styles/subLevel.scss";
import styles2 from "./SubLevel1Desktop/subLevel1Desktop.scss";
import HelmetComponent from "../../../utils/HelmetHelper";
import { handleSearchPage } from "../../../routes/Search";
import { NewAdsSection } from "../NewAdsSection";
import { DiscountedAdsSection } from "../DiscountedAdsSection";
import { CategoryNameHr, ModuleNameHr } from "../../../models";
import { mapCategoryToEn } from "../../../routes/LanguageMapper";
import GoogleAd from "../../../components/GoogleAd";
import GoogleAdInterstitial from "../../../components/GoogleAdInterstitial";
import {
  selectModules
} from "../../../containers/App/selectors";
import AgeVerification from "../../../components/AgeVerificationModal";
import { checkEmptyArray } from "../../../services";
import { useAgeVerification } from "../../../hooks/useAgeVerification";
import { CarStatistics } from "../CarStatistics/CarStatistics";
import FeaturedStoresWidget from "../../../components/FeaturedStoresWidget";

const pagesWithFilters = [
  CategoryNameHr.car,
  CategoryNameHr.motorbike,
  CategoryNameHr.commercialVehicle,
  CategoryNameHr.constructionVehicle,
  CategoryNameHr.trailers,
  CategoryNameHr.buses,
  CategoryNameHr.agriculturalVehicle
];

function SubLevel1(props: any) {
  const [loadingState, setLoadingState] = useState(false);
  const [config, setConfig] = useState(null);
  const [isPageWithFilters, setIsPageWithFilters] = useState(false);
  const isMobile = isMobileScreen(getWindowWidth());

  const modules = useSelector(selectModules);

  const {
    match: {
      params: { category },
      url
    },
    module,
    getSubLevelCount,
    ads,
    categories,
    showHeaderLogoAndSearchBar,
    metaData,
    moduleName
  } = props;

  // Use unified age verification hook
  const { ageVerificationModal, shouldShowModal, forbiddAds } = useAgeVerification({
    module,
    category,
    modules,
    categories
  });

  const [routeLinks, setRouteLinks] = useState([]);

  useEffect(() => {
    if (categories && categories.length > 0) {
      const foundCategory = categories.find(
        c => c.name === mapCategoryToEn(category, module)
      );
      const categoryName = foundCategory ? foundCategory.displayName : category;

      setRouteLinks([
        { title: moduleName, link: `/${module}` },
        { title: categoryName, link: `/${module}/${category}` },
      ]);
    }
  }, [moduleName, categories, module, category]);


  useEffect(() => {
    pagesWithFilters.forEach(page => {
      if (window.location.pathname.includes(page)) {
        setIsPageWithFilters(true);
      }
    });
  }, []);

  useEffect(() => {
    showHeaderLogoAndSearchBar;

    !module || (module != ModuleNameHr.vehicles && setLoadingState(true));
    category == CategoryNameHr.motorhomes && setLoadingState(true);

    if (!module) {
      const module = url && url.split("/")[1];

      getSubLevelCount(module, category, 0, undefined, () => {
        setLoadingState(false);
      },
        location.pathname.includes(ModuleNameHr.mobilePhones)
      );
    } else {
      getSubLevelCount(module, category, 0, undefined, () => {
        setLoadingState(false);
      },
        location.pathname.includes(ModuleNameHr.mobilePhones)
      );
    }

    handleAdsLoaded(ads, config);
  }, [ads != null]);

  const handleAdsLoaded = (ads: any, nextConfig: any) => {
    if (ads && ads.data && ads !== props.ads && !nextConfig) {
      // const config = { ...adConfig };
      // ads.data.forEach((_: any, index: any) => {
      //   if (index % 5 === 4) {
      //     config.slots.push({
      //       ...googleAds.subLevelMobile.box3,
      //       id: `googleAds.subLevelMobile.box3-${index}`
      //     });
      //   }
      // });
      // setConfig(config);
    }
  };

  const categoryCount = categories.find((cate: any) => cate.name === category);

  const renderSearchSection = (isMobile = false) => {
    const {
      match: {
        params: { category }
      },
      ads,
      tags,
      onTagRemove,
      onResetAllTags,
      onSearchSubmit,
      categories,
      modules,
      module,
      location,
      numberOfControls,
      selectedCategory,
      loading,
      updateCriteriaModules,
      criteriaModules,
      level,
      subLevelSearch
    } = props;

    return (
      <SubLevel1Desktop
        ads={ads}
        categories={categories}
        categoryName={category}
        criteriaModules={criteriaModules}
        isMakePage={isPageWithFilters}
        isMobile={isMobile}
        level={level}
        levelCount={categoryCount && categoryCount.count}
        loading={loadingState || loading}
        location={location}
        module={module}
        modules={modules}
        numberOfControls={numberOfControls}
        onBoxClick={props.deleteSubLevelSearch}
        onResetAllTags={onResetAllTags}
        onSubmit={onSearchSubmit}
        onTagRemove={onTagRemove}
        selectedCategory={selectedCategory}
        subLevelSearch={subLevelSearch}
        tags={tags}
        updateCriteriaModules={updateCriteriaModules}
      />
    );
  };

  // if AgeVerification state is not calculated yet, we should not render
  if(ageVerificationModal === null && (!checkEmptyArray(categories) || !checkEmptyArray(modules))) {
    return null;
  }

  // Check if age verification is required
  if (shouldShowModal) {
    return <AgeVerification />;
  }

  return (
    <React.Fragment>
      {!forbiddAds ?
        <GoogleAdInterstitial
          config={{
            ...googleAds.interstitialSlot,
            id: "googleAds.interstitialSlot"
          }}
        />
        : null}

      {checkEmptyObject(metaData) ? (
        <HelmetComponent
          title={checkEmptyObject(metaData) && metaData.title}
          desc={checkEmptyObject(metaData) && metaData.description}
        />
      ) : (
        <HelmetComponent
          title={`${"Odaberi potkategoriju"} | ${"INDEX OGLASI"}`}
        />
      )}
      <BreadcrumbBar
        className={styles.breadcrumb}
        routeLinks={routeLinks}
        category={category}
      />
      <div className={styles.titleHolder}>
        {checkEmptyObject(metaData) && metaData.h1 && (
          <h1 className={styles.title}>{metaData.h1}</h1>
        )}
      </div>

      {/* {isMobileScreen(getWindowWidth()) ? (
        <SubLevel1Mobile
          level={level}
          categoryName={category}
          module={module}
          subLevelSearch={subLevelSearch}
          loading={loading}
          levelCount={categoryCount && categoryCount.count}
          isMakePage={isMakePage}
          onSellectAll={handleSellectAll}
          onBoxClick={props.deleteSubLevelSearch}
        />
      ) : ( */}

      {!forbiddAds ?
        isMobile ? (
          <div style={{ marginTop: 20 }}>
            <GoogleAd
              className={`${styles.ads} ${styles.adPlaceholder}`}
              config={{
                ...googleAds.subLevelMobile.box1,
                id: "googleAds.subLevelMobile.box1"
              }}
            />
          </div>
        ) : (
          <div style={{ marginTop: 20 }}>
            <GoogleAd
              className={`${styles.ads} ${styles.adPlaceholder} ${styles.adPlaceholderFirst}`}
              config={{
                ...googleAds.subLevel.top,
                id: "googleAds.subLevel.top"
              }}
            />
          </div>
        ) : null
      }

      {renderSearchSection(isMobile)}
      <div
        className={`child-center ${styles2.container}`}
        style={{ marginTop: "0" }}
      >

        {!forbiddAds ?
          isMobile ? (
            <GoogleAd
              className={styles.ads}
              config={{
                ...googleAds.subLevelMobile.box2,
                id: "googleAds.subLevelMobile.box2"
              }}
              noBottomMargin={true}
              noTopMargin={true}
            />
          ) : (
            <GoogleAd
              className={styles.ads}
              config={{
                ...googleAds.subLevel.bottom1,
                id: "googleAds.subLevel.bottom1"
              }}
              noBottomMargin={true}
              noTopMargin={true}
            />
          ) : null}

        <div className={styles2.newAdsSection}>
          <FeaturedStoresWidget
            module={module}
            category={category}
            isMobile={isMobile}
          />
        </div>
        <DiscountedAdsSection
          className={styles2.newAdsSection}
          module={module}
          category={category}
          isMobile={isMobile}
        />
        <NewAdsSection
          className={styles2.newAdsSection}
          module={module}
          category={category}
          isMobile={isMobile}
        />
        {window.location.pathname.includes(CategoryNameHr.car) && (
          <CarStatistics />
        )}
        {!forbiddAds ?
          isMobile ? (
            <GoogleAd
              className={styles.ads + " " + styles.adsBottom}
              config={{
                ...googleAds.subLevelMobile.box3,
                id: "googleAds.subLevelMobile.box3"

              }}
            />
          ) : (
            <GoogleAd
              className={styles.ads + " " + styles.adsBottom}
              config={{
                ...googleAds.subLevel.bottom2,
                id: "googleAds.subLevel.bottom2"

              }}
            />
          ) : null}
      </div>
    </React.Fragment>
  );
}

SubLevel1.defaultProps = {
  level: [],
  ads: {}
};

export default getModuleContext(
  connect(
    (state: any) => ({
      level: selectSubLevel(state),
      subLevelSearch: selectSubLevelSearch(state),
      categories: selectCurrentCategories(state),
      isMakePage: selectMakeDatasource(state),
      moduleName: selectCurrentModuleName(state),
      ads: selectNewAds(state)
    }),
    {
      getSubLevelCount,
      deleteSubLevelSearch
    }
  )(handleSearchPage(SubLevel1))
);



// WEBPACK FOOTER //
// ./src/containers/ModulePage/SubLevel1/index.tsx